export default class CountryService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getCountries () {
    return new Promise((resolve, reject) => {
      this.$http.get('countries')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createCountry (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('countries/store', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateCountry (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`countries/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteCountry (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`countries/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
